export default {
    button: 'i-button',
    icon: 'Icon',
    slider: 'Slider',
    rate: 'Rate',
    upload: 'fc-ivu-upload',
    cascader: 'Cascader',
    colorPicker: 'Color-Picker',
    timePicker: 'Time-Picker',
    datePicker: 'Date-Picker',
    'switch': 'i-switch',
    select: 'fc-ivu-select',
    checkbox: 'fc-ivu-checkbox',
    radio: 'fc-ivu-radio',
    inputNumber: 'Input-Number',
    input: 'i-input',
    formItem: 'Form-Item',
    form: 'i-form',
    frame: 'fc-ivu-frame',
    col: 'i-col',
    row: 'row',
    tree: 'fc-ivu-tree',
    autoComplete: 'AutoComplete',
    group: 'fc-ivu-group',
}
